<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>New Service Connection Report of Temporay Connection  Consumers</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <hr/>
        <div class="paddingLeft30px">
           <br>

      <div id="ConsDetails" class="" style="width:90vw;font-size:0.8rem">
          <div id="fyShow" class="mt-3" style="display: none; text-align: center; color: #22739F; font-size: medium;">
            <!-- New Service Connection Report of <strong>Domestic Consumers</strong> for the financial year: <span id="fy"></span></div> -->
            New Service Connection Report for <strong>Temporary Connection Consumers</strong> for the Last 3 Months</div>

            <b-table id="domestic"  :per-page="perPage" :current-page="currentPage" bordered responsive :items="report" :fields="reportFields">
              
            </b-table>
          <div id="noData" style="display:none; text-align: center; font-size: larger; color: #9F3A22;">
              No data availabe for the Last 3 Months.
            </div>
              <!-- Pagination controls -->
             
              <b-row>
                <b-col cols="12" lg="6">
                  <p class="mt-3">Current Page: {{ currentPage }}</p>
                </b-col>
                <!-- <b-col cols="12" lg="2" md="3" offset-md="3" offset-lg="4">
                  <b-button variant="outline-primary" style="margin-top: 1rem;" size="sm" @click="generatePdf()">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                      Download Report</b-button>
                </b-col>  -->
              </b-row>
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="report-table"
                  @input="currentFY('current')" 
                ></b-pagination>

                  <!-- <b-button
                  @click="currentFY('current')" 
                  >Next</b-button> -->
                
              <!-- <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="domestic"
                    @input="onPageChange"
                  ></b-pagination> -->
              
      </div>
      
      </div>
      <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg" >  </span>
        <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
      </b-modal>
  </b-container>

<br><br>
</b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var consNo="";
var sdCode="";
var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },

  data() {
    return {
      selected: null,
      tableRows: 0,
        // options: [
        //   { value: null, text: 'Please select an option', disabled: true},
        //   { value: '2021-2022', text: 'Financial year 2021-2022' },
        //   { value: '2022-2023', text: 'Financial year 2022-2023' },
        //   { value: '2023-2024', text: 'Financial year 2023-2024' },
        //   { value: '2024-2025', text: 'Financial year 2024-2025' }
        // ],
      reportFields: [
        { key: 'slNo', label: 'Sl. No.',thStyle: {textAlign:'center', width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'consNo', label: 'Consumer Number',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'applNo', label: 'Application Number',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'applDate', label: 'Application Date',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'meterCost', label: 'Meter Cost',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'loadSecurity', label: 'Load Security',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'installationCost', label: 'Installation Cost',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'processingFee', label: 'Processing Fee',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'billAmount', label: 'Bill Amount',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'paymentDate', label: 'Payment Date',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'releaseDate', label: 'Release Date',thStyle: {textAlign:'center', width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            ],
      // report : [],
      // currentPage: 1, // Current page number
      // perPage: 10, // Number of records per page
      // totalRows: 0,
      // show:false,
      // curFinYear :""

      report: [],
      offsetList :[],
      show: false,
      i:1,
      totalRows: 0,     // Total number of rows, fetched from the API
      perPage: 20,      // Items per page
      currentPage: 1,   // Current page number
      curFinYear: '',   // Store the current financial year information

    }
  },
  methods:
  {
    

    currentFY(year) {
    var temp = this.report;
    
    
    this.show = true;
    var parent = this;

    const d = new Date();
    let currYear = d.getFullYear();
    let nxYear = d.getFullYear() + 1;

    var api;
    var noDataDiv = document.getElementById("noData");
    var fyShow = document.getElementById("fyShow");
    var fy = document.getElementById("fy");

    var fiscalYear;

    var j = 0;

    var totCount = 0;

    // const offset = (this.currentPage - 1) * this.perPage;

    const offset = 0;

    if (year == "current") {
      api = '/api/web/eodbNSCReport'
      fiscalYear = currYear + "-" + nxYear;
    }

    var offsetExist=this.offsetList.indexOf(offset);
    // console.log("offsetExist==="+offsetExist);
    if(offsetExist >= 0)
    {
      this.show = false;
      return;
    }

    axios.get(this.$urlCommon+api+'?category=temporary&period=3&offset=0').then((response) => {
      parent.offsetList.push(offset);
      // console.log("parent.offsetList"+parent.offsetList);
        parent.show = false;
        // console.log("response:::::::" + JSON.stringify(response.data));
      
        fyShow.style.display = "block";
        // console.log("fiscalYear::::: " + fiscalYear);
        // fy.innerHTML = fiscalYear;

        

        if (response.data.EodbReport.message.length != 0) {
          fyShow.style.display = "block";

          var data = response.data.EodbReport;
          
          // console.log("data::::::"+JSON.stringify(response.data));
          // parent.curFinYear = response.data.nscReport[0][12];

          var obj = {};
          totCount = data.count;
          data.message.forEach(element => {
            if(element.connection_released_date != null){
              obj = {
              "slNo": parent.i++,
              "consNo": element.cons_no,
              "applNo": element.appl_no,
              "applDate": element.application_date,
              "meterCost": element.meter_cost,
              "loadSecurity": element.load_security,
              "installationCost": element.installation_cost,
              "processingFee": element.processing_fee,
              "billAmount": element.bill_amount,
              "paymentDate": element.payment_date,
              "releaseDate": element.connection_released_date
              };
              temp.push(obj);
            }
            else{
              j = j+1;
            }
            
           // console.log("temp::::::" + JSON.stringify(obj));
           // i=(parent.currentPage - 1) * parent.perPage + i + 1;
          });

          // parent.totalRows = response.data.count; // Assuming the API returns the total number of rows
          parent.totalRows = parent.i-1; // Assuming the API returns the total number of rows
          // console.log("Total count:::::"+JSON.stringify(totCount));
          // console.log("Null count:::"+JSON.stringify(j));

        } else {
          noDataDiv.style.display = "block";
        }

        // console.log("total rows:::" + parent.totalRows);
        parent.report = temp;
      })
      .catch((e) => {
        parent.show = false;
        parent.$bvModal.show('model');
        document.getElementById("msg").innerHTML = "Sorry, Please Try Again Later";
        console.log("Caught :::::::::::::::", e.message);
      });
  },
    



    generatePdf() {
      var header = ['Sl. No.', 'Consumer Noumber','Application Noumber','Application Date','Headwise Amount','Bill Amount','Payment Date','Release Date']
      var temp = []
//      temp.push(this.KeOfficialfields)
      temp.push(header)
      var i = 1;
      // console.log(this.report);

      this.report.forEach(element => {
        var temp1 = [element.slNo, element.consNo,element.applNo,element.applDate,element.headAmount,element.billAmount,element.paymentDate,element.releaseDate]
        temp.push(temp1)
      })


var currentDate = new Date()

var dd = currentDate.getDate();
    var mm = currentDate.getMonth() + 1;

    var yyyy = currentDate.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    var today = dd + '/' + mm + '/' + yyyy;

      var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: [
         { 
                                alignment: 'center',
                                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAFPr3GUAAAACXBIWXMAAA9hAAAPYQGoP6dpAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAA0i0lEQVR42mL8/+8fAxhEMUFoRiD+z7AESEoBsSsQ/2VAAgABxMSACv6DIQND9H+vYkcg/QcsxsAgAFMAEEBMKIph4BsIf0Q26D0DK68ag64rA0AAMfyPZGb4H8jxHwT+hfH9/x/B8P9fX8T//1/e/f8fxADmw0E4OwNAALEAdQIN+MDAEMnIwAi07/9yoEVnNjMwJAsxMCx8zsAQrwyWg/ovDCCAmBh+fUgBexSEPzMw/P70jIGxwY+BYQVQ46ltDAxsLBDHfgObuxIggFgYpj8RYRCQZlD1/c/Az8vIcJoPKL/mEwNjjTsDAzAE5d99ZGAG2nxvO1DDo4sMAAHEaBj+n4GJEeLhz1//M9wsWcSg3R/PwMnBwHC69wYDo5Qyg0kkK9hF338yNAAEEBMTIyIobm5iZNCCKgYB02INIMkKl+dkZ2gECCBYsDKCrFXzYWDg4kCNGNMoBgZeLrADloMIgACCx8Ofvwy8fLwMGOA/UO3nb4wgxVEgPkAAwTUwMjJ8gYaVK5L6FqhYFEwAIIAYwWkpkgkiDBGyBJo7G8iYCMSzkW0DCCBkxX/htqkBk9Ct/SjqQARAAIEl/5uG/Ud21v//fxn+f0JLjMD0AxBATAwxrEKMqVOA/kakN0YeUQaGhnUQDsg3ILnf/+8CBBDj/3CgLph7/wCjNamdgWFRNkTBp9cMDGlicP8ABBATAzMDwnP+0Qz/XRIYGPpuMjB4MDL8unsQkvp/AzHQWQABxAhKnW+BidI9k4HBwZyBoeccUOdrdgYGIUEGhh/vGEzYfjJsn8rAIApMpAABxGISifBFT+g1YHYwYTD5fZrBXJeBYWrMdYb/JQwMntkQeYAAAoVAMDgT/QASv14zmNw6DZY4eRHomgMaDEvaEIYBBBAwITOAvX1tPQMwxdmjhNeyrYwMsqL/YZ5iBAggRuOI/5h5FTOdMAKTBANAADGhxRIIv8IiBgYAAcQIL2dAACWNMCgC8T0UK0D+YkZJ8iAwGYjzsLkIIICYsLkSiu9hyKwHCq/B8F0ukh5PZAmAAGL8f2gRhGUbCywqGHj+f//AwBgBjEMuNBubTjAwqppDUs2bRwwM1SYYzvyvZMfA2AxMKL9/MgIxA0AAMQLLMhD4BffsT1DwNDAwhNYz/D+1hoGxP5SBQdyCgaF0HtDzWsBgASqTB/K/vQAmptsMDKnAFOSaxcBwBJhve4BZkRPhcIAAYgGmYQmUUPwPjIO3TxgYds5gYDy1moGBhY2BQQ+YRYVkGBjYQSXRb4b/wfnAojCEgUFWhIFhH7AauHmCgUFOj4GhaTeQ1gH6H1iys3B8BwggBqDLJ/4PBaYGfyDuj/z///tHcIHsnfPvv3YQkJEo/v9/AOt/UAb7B4LzCv//j4SW3OvL/qt6////4RuQ/ff3///T0///9wPKhUJKd4AAAqlSX7b1339loCIToNnAdAnGZlGgTHXt//884///H135/z+B/7+yJ9COKmBVsXXC///uQK2f3/xftPkfXA9Iv4LH//93H/0D2w0QQLBE/h+9mNk4CVjn/b0D9HY/g/LiqQyCAqjx5wwM9s68f+ACXz8CWOuwYKQtRoAAYmFArkVhJYUT0GBgNlPxUWEQ4MU0GAT2AoPZ9CQTQ3IAE8PF1aCsyoBRDAIEEHL2BAF1Ntb/N15/YGTg52YgCUws+89Q2M344N9/cOYDA4AAQjccGYCKFxMizQaltj+guoQRqUYDCCBE9n98g4GhXAuLPkZuYEMiG6gniAGStY5Bq43r+GwDCCAWPHKgesSBAal4ZzAOZGA4ux5YpDKkQ0X+Qi37ha4ZIICwlSnO0Eh1QBEFeaxkHaTsRwBmaF6+j24IQAChG7wYiPdg9wAPsDgHZmkBSWySCuhJGCCAEEEhq1HJ8JUhhgFHqvi/8jMiSKIYcRX1oMoUrAwggCAloAqwZJNUgyjNVgdWULdQNYJCUN8NWF9OYfh/fBUD46wapEYgvI3HwLAZ2KZi5VzD8O1TKEAAQVp6vsAsOy8X0aJ7cQtcZoBbeSC8vA4i7gxk757z///CUoQcCM9B6P13ZS+wDGFhAAggULHKzACLEnCxDkyWi94CSzlgw8cb6Ctg8c3g1wjkA8NoJbBuXQZU9B5YMmbJghuEDFuA/L/AmjwT2HL88BgSncByEyCAGIHtzx3AotIdpYpkhLQ+GWLKgQYCmxAiQEMmx0GygoodA8MJYFKefhSYIOcDa58ZkGBBC3OAAGJhWPvfHUXkDzD13DgCbI4Ck9aJVQwMT+4z/O89z8DAp8zA+P0uw39FQwbGUqB4hjSw/FZhYLD3YmCQ1oGU0UqGQEfIMzBw8DIABBALQzQjaoXOBHWtuDzD+5LZDIJTChgY8w0Z/ncfZfh/YgOw/XWK4f/XjwyM74B5w1yTgWEXUExgG6Rd8xuaZYA0QAAxgAM/AIjj+P//P7cNHAHHL/3/r+z1//+qo8DIAAmACvxECUjsBALZfmz//7e4/1fx/f+/oAsaa7dPANUIQ+SBZgIEELjhBAuFWmD1tuUQA7hxzQTEp3yLGRi2Ab397hkDQwUw7/ACSw39aAbGGKAvl/xneATsUwRnMIC7AQbq/xlm1SFKIYAAAhsMahaDyiLk0klY4D/Dzh6gzlBBhv8TjzFMuWPJMG8BA8P5pl3AlAJMAQeAlev/LwxayzsYuDgRrWUlYNCv7mVgAAggJmBh/Ry9yAM16LdPBxKdYcBOyEOGqbctGRYugvhEvwaYUf6+ATYVgLW4ohmDhiJSOQjUcv8ZpAIACCBQmSwL6lEgJ4wPwPR5ZxMwaf/5zTBhDyfD0iUQ18DAF2AGu7HxN7ziR6tJQOAtQACB0sBjdNHp1UBT/jMyTN/GybBkMaqh4OIIWFBqByFaE9++YxZKAAEEK90skXsVrpaMDFNWMzPMXYm7sAb2aRiUvCHs5EAUm0GdsC8AAQQzGFhNMoD7jQpS/xlmrv7PsHAj4TpJCJgp1XwZGIrjGRmYmeHC4PIRIICQy2MBUOSEAuNm9jpG3A1gNMAHLKYVgS5//+k/inkAAYRaoUIa2U+h3WqSAKzBDQMAAYStagKmRAZ5Esychtw4hwGAAGLCofgRVDGwtcgwH4s8sLvCoANVk43NAIAAQm39wwCoKVCmhcUdKABUUmcC1SQDg1AJ02RoNcuGVS+w+GSYAMSboEUWSQAggJhIUAtKUxuRehDvgLgVp4NB1eAqYH3JwofNLBsgXgOtUP9DK7FSYh0CEEDEOLoByWA/okwFdmf/d+2BdD5mPoTkSMIB0gW1BxT1hvgUAwQQE472BwivhLLqSYo7oNf+R1UxMH4BRsTCImCH8iuwtliDNpSFF4Di6RzUbm8GFmCpL6uLggECiPH/f4wSAthBYDgOZl0C9pYq3cBNOAZiE5IUsJdVsIzh/8XdDIw+BcAmRAywWwos3NuBFcjl1QxEFUiM0HgF9aBzp/1kcEjkQC7HAQKI8f/ECES5rOs8jcExJROl2oIVVWubGf7PqmNgFGXAGWr/gcmAcRkwhGcCO8/xrcDMDGzBzAVm6jQloN57DIzhwC4ky1tIAsAVS0zAEKrfzMCohdqoZvj81oLhx5eTIHcCBBCskwyuo4A4A57rQVgdGB1JwH6CtiOqAV3AfsSR9QwojWBQxlv7luF/rSsDYyewQeYPjFZ+UC4AZokIYHs1Thro8FsMjEH8kHLnP9J4hAQwL7ccADYWZJHyxStgVm1iYNg9H1LtcoFj2xRIngEIIMb/YWBOAGjEAW+U/YOMSP03cmZgBIUisKEN7EsD22TGwHr+LrCoBjZ/mvyBTVRgSAcBa0nOXxA9IEdNBYY2KI3PqQZ6JpWBoRrYunF0YfhfuYGBkQ3o87ungC2UNmBfaiOkiGTDN7DDwAUQQIz/X9wBtTr/M7wC9ltegDAwt78H4g/AmuvXb0QpChsIg9GgNP4dWmh5xTL8P7KRgXHFR4b/SRLA1upLVGtAw2+bgc22+aUMjA+BLdrPwIbQ9YuQoQs2pEL0P5Jj/0ExbKzqH1QtC9NqgABi/B/CYQ5s9p5g+AUMkp/ANPEX6Ir/QPwHiP9C+X9+IQyAlTl/oEmIHcj5CZRcBXRoJ7BFax3JwOiWxvA/kAfYjvzD8N8nh4ExdTLD/04/BsZyYF2SrQYMEGAT/AfQBcJAD3IAy3E2YNxzA0OcG5hueIHJh1cYmPmFgGEK5PMBaV4QG9jw5wKmdw4eBoAAAqVp0ABqNdaI+A0NSSEJBgYzT2CUxjMwqJoyPP3OxdAyk4HhKLBguhSQD2xHApt2BxYCm+gzIOM3wPT9fxkwpgSlGBirgPXIraOQjOqYBHT0XAZGX0aGEwXXGBZe0mToBmrn+Qis2Y8Dm/e7ge3Se2chscmOu2QBCCDG/14MvQzCgkUMek7AegqYK02AjSoWhI7fQIcv287AMGX5f4YfvxgZ2NkQTdZbc+8xMB1YCvQUsEiZmgnJLP+4Gf6vAKaH9cB0vx3UaQQmg2pgj+nuYUgyadvB8J9fkoGx15eh0fghw8YdkKj/CoxoJ7P/DE2ZjODhU4QDgBIngEXlwWUMDBcPgEdIAQIIVE4Dcw/DBpiaoxeAsTwP2LoH5h0RYOyAhnHQmyevP/5nOLmUkUFiBTBTOQNDr8gK2DJmYmBc+ozh//XjDIz9CQydEa8Z9u9hZdhRso+BYQfQ0pQJDP+DeBkYge1yhrUfGP4vbwCWJMkMdoU6DD9BKfEfooEPKn1fAfMtaHi3PQ+Y5+VQ7QcIIMa4mv+cZ68yfAM2xxk42YiooYEV3IQKYN77MpmBwQoYM25iwKJsLzCOhRkYJwQxTHS6yzAD6GkeTkgW+A1M++YGDAyzovYx/H//nYHx9zeG/w1hDIzbgRlzWiLDl5T5DAaBwMjix+wHwAsuoIe+AANcQ+E/Q0ce402AAII1eIE9IoYiQg4GFSYBwFTUFPOE4T8zMFOs62RgDAC2c+aEMUzR3sMwaRIw3/Bi1/sDmGndgcm7N+02ML3KM/xfWcPAGAosw7++Y9hyWYahtB+YDzmJqnN1AAIIuZUOGmnSwNMKZxAHVmjbpkDLoL/AIDwyg2HmlxyGbmBzWhBPSCH37b4Ci8kIj/8MdemotW5eBwPDYWDSZMbfHK4FzbwABBD6WN1rIBbBGspAN15aDcscHxhmbxZg6FtEdOhgAJDjC6L+M6SHIVypHwLMQ6w4tcwE19hAABBA6M0gUMtiFbrqj8CS4gR0vH3Kiv8Myv4CDLPWkO9gcDcPqHfOBkYGRWBJumgzJOAOAWvsdx+xKneHORgEAAII16ioILSRz/AZmPFW9fxnOH2ZgaF/CSN8zo7aANS8mFD2HxgDjOBBEeh031Vo1wsFAAQQvqFcUBqVB+bqu09fMjBzcTLQHIASCqiUEBNguAYst7VxqQMIICYChjx8/4mBBehgkHlTaOzm38Dg8+fmAPYfvjNo48vUAAFESh8xF2lOTB3aKvxPgSNBya8ZMkoM751vIkYjQABh9sZB5ZIfsPLn/kdchDL+Bw2PyANdb84I6fVoArEkdBD6K3Rw6QoonwHxeVheoQQABBAljrYGKi4HOtoT6GgWrP3MfwywIV5k8AY0RQodQrhPjqMBAoiJDD0F0OHZIwzgoXEsDgbNI7JLMTBIq2NLQCLQWdJ70ArNhlQHAAQQKY72h47GAStccEcKT30PjAMzbwaGwBpCQzGgGhjY/GO4DOp0EesQgAAi1tH7oC1BPqLKLVBKDq9i+G8Xw0BomArWngDi58S0f0AAIIAIOVoQmhQciR8qBGIZeWAiUIA4V8eGlDIG1HDbQkgRQADhy4gySIOFxANQvzFrOsN/YDeKUdmI4T+wq8ZYqI+7J4IdgAYhcVYuAAGEfZrwzz9ZoFMfkVUKszAz/HfLYGCcCOxxv7jNwBhWD5n9ZfxDSoiDJkLvAEsfFQZ5XQxJgABiwpoqJ528+/83J+5BFTzDDP+tQhgYLwOzgEUwsBnwD7wC639oDTnVkDJQz24GAWD+RMMAAYRtWOwGuMYDiVcD0+PlY8DeMJF1H2igcclrhv89oQyMjdB1QQuLGRhCgP3mYGFIDiE2p4Gm9VT1GBjqdpYycPL3IEsDBBATw+HFDGC8bw6InwOtosFp+38bsBedN5X4OoxPADx3yKhgCNTzBNxP+n8NWJxzA3uqSgaExwNhY3gfWRn+lwB7973ATjG/RDcDG6cEw+9f4HkfEAYIIMRYHgMjN0NM5xcGIVlMwz4+Z/ifb8HA+PURAwMLnqSRDeyZHwAGQN12BsZsoMMrloBHTf8/OMfAyAGMru4YBlzzyWAPAQPnv3s0A2PufMgwMQJcZnh6Q4+BFdJeBQggRtCULxj8/beM4eP/SAYtYMKPbWNgMPTBNHg2MCI2ToUkF/QQAlY7/9d/YWDsAAZCIdDSEFFghoxhYCwGeiJGiOH/EqCLfBgZGPmwJDVQ6HIBmyvNOxkY5NAy3vdPDP+3TWJg3NTnyPDz2wGQEEAAwQYg+cDWMkJHREFpkwtYRnllASuJJvCoDrwYvnOKgbEM2Oxg/YOIbpA+faBBgoIM/+M6GBiXAkuMHRMglcy2/+BR1P9OUQyMa4AdwfObEO0RUOyA1CS2MjAGV6E05P+f28LAuBzYJbx5ETLbx8ZwCWiPPkgaIIBgji4H4g6MkP0LGz01ZWBIA3a1VSwgZgI7tYyVlsAsewYS6m9BGRDYlKi0B8YGsKT0Z2Fg5PkLqcJLgRWpsgkDQ5UrA0MZMPnkGUEaAaAGgSqwKG4/Dp6BBoNXQDNWtkCmwBmxzteARkAeAwQQE7RYy8M5qQAaNXpyGljBWjL8jwRmtA3twCIXWIN0nWb4n94PdvB/EVmG/2eBUZs5G5imFzEwsv2FFJeg9D8X2L4SkmZg+PQFaKUaAwMn0IFfgBI1qxj+91+BOG7bRIb/icBaNEmZgeH4fEhFhH0MpgREAAQQ4/8oHkWG31/ugS1gRBu5xJZZfkBHQQ2AoZ7UxfBfXJWB4e5pBsbeWGCDE1jjBwNtZP+FMOMbaNEGMK2fXM/w/9B6BsYQoCc0gMnrNLAPsRwYqtcvQEZPuRiIqRdA8c4BEECMwLSTzvDizgyGF8Coef4QGHJA/A6Iv7+HOJABqb/ChISh49UMwsDy19wX2EZTY/hv4MzAWGSOWkKAkpgN0EPZwFjwBOb+CGBm3joTMvLDjTSM+x+p7cKANNsAa5czQUOfnUMUIIBAlQuoi+OLu5YD6v4BLOlfA9vrz+4yMDwFNgseA6P1FZD95gEwJN9BmvVbfzL8X93AwKjpAKyU3BGN15/AMrd8FbCpGgDMNcDW7alNkAleTmBNwyEMzrzgYV1+caC4GIQGYSFJSA3ICTSIjR2yso4JXN46AQQQ4/9yq/cM378JgMenwWPSoLHon5CCHDQ+/Q8k9hfi8//QdP4fOgQMEuMFZm0DD2CuWAAsOcQYGNf9Yfi/ohaY84FR/48NmDReMjA+vMjw/8NrBkYhYMegGJg0uIHtEzZhBkZ+oKNZgemCAzQ2DUzrvKDxaWC+4RGBjE3zQsenQePWXEDHc/KAxrIbAQKIheHxMQGszUtYsmCBYtioPwtodYAZsDgMYHioEM4gPyOegSEVWLLMSAO2i4C+yAeWShOBjnx0i4ExZxY4Rv4XOABD2obhf/NhoEP5GP6bejMwagHb/5tWAJtF50D9TEhSgQ3W/4cGyF8kNmJWwAgggJjg0wT/0KYM/kIb8yDHygJDJx1YqSwEJpE1XxlWeexn0J+Yz3DjGTAUHlxj+C+qwMBwcC3Ec4+BxWkfsEwuW8nw/+l1BsYsYwZGUAfr/BEGRmAy++8BbAHe2sXgvKuOYV82MKltAubUTmCdYQ5aFC2AmCgFpV9YBuWF9pUEwUrkAQKIBR6ysMXDrEDvygPLTxugIZbBwAymAvbeV2BKmQSs3JZsB/oLqBZUo7ozAEuEBGARuKYZ4uD/EDP+G7lBGuGSwGYMJwtEA0h+12wGxlBgJbKiiyEXWP8kA/spEiLsDI3Z9gxuBdDFwR9eMDCc3czAsAeYcW+dAa3mg1QurPAUwAsQQIz//Zn/MygCm6/WQcDmZCiw14Ha9r4FbG60zfrPcOIyZEiMGVoLRgYCk+dVWwaGRmAXLwQYt2zfILNf6X0MjJ7AEsIJGFQLzzL8Z+VkYEwGmi8MCj1gWTwPmHmTJBh+tB9g0IjXAI/6/wAmO07W/ww1GcD+hz1an+PRJUiD7vAaYH3xABR+twECiPH/n5//GZgxS/J9pxgYWmb/Z3j8nJFBEFjJ/0Mqu98AS8Ora38zcC/JZmAwBZYK9d6QkPDIBq91Y/ATBWbMbGAmXMrA2H2E4f/V/QyMbZGQ2FwKtPgisL395SZD5PEOhruPEGaDZgRYgGHYkMnI4O+Imc0YvwHrgSt7jwMEEKjI+wfJcv8ZPgJDavpKRob5myCj76B1LX/RCnzQ+hZ1JQaGRf7ATGQMbAOkaDL8/3yDgdEqHtgSXABsQwgzfM1pZlDuz2LYBiyOjbqBbeJOYI26GliarG0BdhLigI0oYLMzV4/hRPYlhmhgc1sQqbsMiklQ5QlyZHEcMFICEbELBXMBAgjEvfbkxX+G1CZGBsNwRoal24BpngeC/2KpoV6/+89QkgAazwRGxRNgRnoE7DMo20EcnKnB8KNsMoPprCwGBaBDAoHqrlUCo7fNk+F/VDPDfx0nBsYd0DFjeUUGC2ABwsEG3n6BqIuAdnIDMx8vMMX1AVOFLjBbzUQdfD4GEECMrhn/ex8+ZSgCjRczEWikg+T/AEuVcyuArZ1X7xn+9yUAo+wVMIcCHV9iyfAjrobBtM2bgQNpeSVobHsn0HKlDZnA9sV0BsYYMWAROBfYegeWFOzMDBWbrBi2H8E7mM7w8zco5v8zZIQxMoQ6M2gCBBDTuw8MO0C+YiJiBOQrMK9lhII6ZMCyVUgcWHRdYvgPdPD/OleG73kTGCzbUR0MAvzA4soDGM2PAoAO3jWF4f+ipwyMU9OAacyK4f/z+wzx/pDhXUY8fX52VtD6LmCyBTZXTKMZbgMEEGh8mgNaGhOcL3kPDOBLQI1cn58w/F8G7PflApPEtFSG7+G5DKbp+sCoxt7YAgXIG2Btf3LVfwbRt+dAi9DBLT/G14+BzVMzBosYSAwSAY4Dk5IVQADB2m07Ca49AeZ8J2BbiIsNmOiEZRgYUyYzMKxrY/gWUcagn6QPmc7DM6UmAizajIMZGd4KGzEwKgErHFA1rWIK1hTn9x/cfiICTAH5FyCAYImimWDSAHotLRSxv+b/1X0Mv5yTGSwz1BgEuAnPbIEcLgksCS2jGRk+fQNGGxsHNE0wMsQCu2G//hCzZocBPFUFEEAwR4Mmr1/h0yEBrBxMNKFlJrDA/63lzGCeKg7evfWPyDENUMkAKpVs4v6DZ7dggBdYWshLEtQ+DVpnMwAEEBPaEC4Drum4eF9ICwo0zPVbWpPBLJ4H6GBGgiGMbT6SnZWRwTIWNUmkhxBM1/BOJEAAITt6OXTIFXMyBGh4chB05vUPK4N+CCuwiGIkOoSxNSLZ2RgZDMJAfQGIIYFOoLlFnAYWQ5tvYAAQQOgFnQM2HQ4miKliA2AFxMPBQHIIYwtxUN0AWlALCmFQ8nY2w1r0ggbf+5AFAAKICcvkTQqyAGiJRG3af3C7wAqYFvm4KJsdQnc4GzDGQGkcxE4PYWR4/wlDmRm6AEAAYatS5jJA14CyANsZYsL/GaTEGBksgGmQmZmRag5GHaRlZHBI+c9gqAlZqoG0ftcOOkCBAgACCFc9mATEm0G+bkwHdhXC/wM9wEhxksBbpH5lZPDJ/c+QBUzn3yEd6ijo1AYGAAggnDO24E7yf4bFLCwMMeA0R/sJW3DaBq31/vadwRuYtrfhUgcQQHhbHP+B5T6wT5tPDwdDk+Pfbz8YNJjxOBgEAAKIiWDZBGzDQSc039DYzfugPcObhBQCBBCxs1uggXZR6OzTHyo79ik0wzkzEDn3ABBApE5+guYQQa1C0NashxQ69ih04lMGV4bDBQACiJwZW1BlO4sBsiNLFhr6x4iY4PgCnYsELRTlgTr4KDm+BQgg7MvrsTWmH11nYMjRAbZN/1GrKAGWxozCDIz/1YBsXWCu1wX6GzSDqwSdvWUn09z/0LL9ITR/XIU2T0BT2k8YECOUdAUAAcRCJ3tAUSMPTRGgzcgmkAD9z8JAeHs2lrY5IwQz/YdgTLtEoNgYi27Q4l3QSo69oNEjaETQPPABAoiJhmaDUmUGtFwAeQS0smMxtHJWIzmSoSPk/0FLy6UtGP53nmD471UINJmRlN0GICAOLVxBm/fPQHvHILeBZipNGbCtT6ECAAggaqdoRWjgxjGQsHiD6AIBVGIKiTD8D84D9oxNwSsGGK4Di8wbJyFVB/lFmgK0l1EMHc3ezQDZfLybWs4HCCBqpGiQF9OA+AG0h1FG9UBmhOYJYHOTITCbgdE6HCIspc7AEFEHDHwxLFulyQagto83tFgBTUrNgdYbFAGAAKIkoKWgjgD1jWYykLajjrRAhm2mtQlkYPTMBQY6MGm/vAuZHjLwYmAA7f8BDcX8o7rtoEBPBmKgZQxnQfNT5BoEEEBMZBYPq6CNyWQG9AM+qA3+QdOVNrBei2hg+A+a651fxPC/0paB4cRaiJqAMob/9lGQGXba9VWMoBXoLdBYB8aoFwEMEEDEl9EcXLz/FXU6Ge5dymDkAHqHlYGB4T8D7QEokCVkGf7HtDMwigCL0ulpDP95ga3CjqMM/zf3gIsTRotQBsboVmCDDtiCu30WspjiH81cpMoAOfbmAtCODAZOgZMMxnYENQEEEBO4jUwIMzDEMojJP2CceDGTcfkbRoaoDmDAS0OWPfymYSCDyl3QLG5EPQOjliMwHzWAiw1GvxIGBjFFYAAD+xHbpzL8v3YQ2JiTgywsAM0Gf6Fxewoy5WgAbK+cYGBkmc/AyMQPnvpmYsaJAQKI8f+XdzhGNIEeZAUd0gBe4x2H1b5nNxkYN3YzMOxfAVl+zw3tZvynQmr/D2l4/ffPBwbgBAbGzX2QVRbJk4G1gQFC3YEFwGprFni/JoMYMMVv6mVgmFcObKT9hVTT/6hUT/yHVsggLCDI8N/aD1hl5jIwKoKb6reg3eUDuIwACCDG/+e3YoqCdkkpmxszCEmDjuQyJDwg8o+B8QawubxhArCDuhWyboEP2nj8R6bHQFWshTsDQ+UmBoYjwCphTQuw4TgDWFY7MPxfBUzhoMPhQuoZ/vMIMjAsALanb5xiYGzeA15Y938WMHK2LWBg5KfQDSDPfYUGrjSw+HKLBW/2YhRTxjqeB8SVDO9fTAYvLkFd48YAEECM/0OwjgyEMnAJTWFQ1BdjMHFjYNB3AVqkxfCflYuIugbougs7gAHTzfD/AjBLswIjgYsEz8KWPMoDu/tN2xn+37vMwDg9g+F/+iQGRlN/hv8H5jIwducz/P8HTO5FUxgYXTMhqwQ6AiCbTVp2MjC8eczA0AfMhBeOQpYrMJKQwxihXZjfQIamJQODHzChmgBTL6cAcRnx8aUpjPsXlDG8efodvJoGCgACCHkzMAz4AS2bCW4Lw5a1/YL2l0SA7VU1E3DA/9d3Z2CU1sRfzf8GevzwCob/azoYGB/ehmRlNgKBDJoL55dgYKxZA+QDFXdFMPwPr2JgdAY2cC5sZ2CYAOwPvX0EUSsMLJdBSzpBu52f3WL43+TJwKgC7DWWLGVgvLyX4X9fPAPj66eQ3PWfcMvmP6g81XNiYPTJgRy+w4pn9xFojOgpsPK9AUxMl/YxMNw8zcDw+hlkUoqdqZ+Bg6kGGDTwrf0AAYQe0JbQtrEWgYoAgkGeFRRiYFC3hsS6NrD2FVeCrYlCLV4+vWJg3AOMv61TGRiev4QslGFHUgDbW/wfGLj5s8A7YRmaghgYHIEVXkQTsDt0gYGhNxmyYgi2GRRUGWuYMzBUrAJXhv9Pb2Zg6I5lYPQCpvKEdvASP4a5lcAc+h2yKOc/Uur+CS0SeDiB5S2wfe5dAJ1/xQJAa82eXGX4f3EPA+N5YI55eBGYID4jNpSwQN3PiFKN10O79eAxWoAAYvwfCfesNHQo0YusCgOW+kGtFEkVYFRZATsTwCJH04YBvDaYiRkR6KBDKjcBy/P9q0EzFZAUB9pYAj7HqJqB0T2BgaEVmJKVdMDrzhjfPwc6GVgUnNuDujWeEdotdwdGQPYciPnLgf5bDmwK5gEj1QWoZxLQrD1LILnpNzQyRUUZGOyDGRjcgEWSnD4ifP4DPfH5NQPDfWCkXgHWa1eARc8DaKCyQBMG8e100MZI0L4r8MEzAAHECN4HzAw0goOhCRhDZVTr2P9F1NL/2VgZGCWB2VzbGljkOANToSUDI2h9JwjcOc7AsBrYLNu8AZgSwxj+JwKLicm5wI4JMPQrVjIwgiq37mgGxhPbIAuf/mJm+/+/gBbGtTAwBgJT709goPSnM/zfu4KBsXU9w38VfWCkhQGLkGcM/wOzgJVZIjBiJcHmMjy/AWx3nwam1APAyvwUsLd5H7KCigU6sMDKgFiSSf6geypoiBYggBj/1wKz/Y/vzgz3rywAulgGvngPVnYxIo1nMSNG0VAwocqFCanI+c6AWDonBQx8fWCv1gxY7OgBU//v78ByFlhc/PrBwFi3geG/ILBN3A8sCnYvwXoSF0qnhkeY4X8OsJFkBiwGXt1m+F8PLBOfPmBgbF/L8B/YUmF8fgtSSZ/eAozc8wwM795ClsuxQQOVmAXBxDZLUdfJ1jGwsrYBBBBocRgoQ4CWd5TCC/l/vyFNvJ/AUPkFLM9/QvF3YKH49T0we72DHBrx6T3kDN6vHyDi30ALfz9B1P76BVmoC1qWCj6n4zdkqQRoRSYj0vgzbM0iaJ/E5//grjZj2TwGBlk9hv9rgb29r8AAuQLsF1w5jnuD2E9oSjdxZ/gf383ACFqRfxGYAyakAQP7KSQgYctimZEiHob/YUkc8ETCBIkFFihmBRrAygY6wRJYlHBC1qeDch+IZueBdLBAfC4g5gQtmeW7zsAvFggQQIz/d89VY9CxWcvw55cOZA3vH0jggFb7gMosUNMJtPgYtFgPxP77HyqOhOH8P5DA/Ac1A5Q9f/8EhvF3SAsEFAGgiPkCOiEMiD++ZmAEYvD6YVArVBRYlhfMAA8U/V9WBV5Ky5gxF7wD4f8eID27goERdKiGENKw6X9mhv9+wCIhFtiyASWKU8DiQs2KgVFWm+H/xi4GxsXAMvsP0Hx+YHriFQPmEuiCZvBCZyCbT5SBEXymBQgLQo4BBQUU6PQHUFsYdOAaM7SHx8hE7mBKIkAAMf4PZfABZudNQP2MDP/Ruq6MWGhGtLL4P3oKQFL3D2lgBdZSAYlzA1OEuBh4Q8B/cXUGRtCq12tnGf5nAtvFnpkM/w8uYmCcUwBZ6Ccrz8CQOZWB0dgbHEH/FxQzMK5cBAwQNob/UcC6JqSWgRG0CvzxZQaGqTnA8vYwA2NiLQNDWCMkl83OZmDYuxxSkYFWkP/8Cyk2YANQsGNamJD88xetNQRfkg8tR0HNTlAksLBCUjmYzQZN6VCaDYjZ2SELs9g4ZgMEEKh5VwHU3U521xTW4viFNO4Byj6gMQcJYAqVA7YUFYEVkjyw8pNSAFbFYgyn73Ey7AGGraY6sKYQAjaX2oBZ3CkGcnrQqY3AAAPWH+9fQ6ZD/0B7iaCBm6xpDP+ltRkYQcUJK7BZxgbsQN0Dtl9nAyPl3DFI0QJyB2iLVTqwVWMXC4mAacBWySlgpefiwXA+chPDo8+sDHZyrxmEvj8EtipuAtvAwDL7PrB18Qy09wHY2fnxA7HfgBUpAhgIJOj/WNiQ4ukYQACBAhr3iRiw8us/UkzDyjpeYPYSB3ZYgFmUQQHYDJMFsiWAgSkIzJZs3PDwv/WEgeHAScipMFeAfZb3nyHFty+wPzAl/i4D22RgYPBIMvyvXAuspE4zMPYDA/zBLcQeWFjOAE23agCLg+LFDKC9a2B/7Ac2/SbnAQ38DAlkmDtB7WsFYCwWLgC2xy0gp61PA0bel5cMn7KXM5SciWBYCbROR42BwVyPgcETGIdWepCMBjYA1G4G9S6fXIe0me9eAi+2B0fCz7+IhgETWmMBN7gNEECgLvhEYIjkgVMOrFJgZ4acvSMCTJWyQNfIGQAxMFXKAlOnALBsA53sxYQataCFbS+BgXH22n+GXcB66/w1oFs/MkKXUUHrEibQYenA/o0yA8P0yp8MktvLGP5fPsXAWL8VUqH2RgF7WSchgcyMNn0VD8x0TikMjB+eA4uWZcAyGBixRsCyHJS6Z+cxMO5dBukEsUJzAdC4/7beDIzZsyCtlw3AMnwesNy3d2a4HbGdoaSXheHKDcgJJKAjwUHrd/h5/jMYa4LWxYMigJFBGFuvG1TvfH4FDHhgJNwFZsv7wNzwGOjZ18AU9eUjpCXDgNSRgXRm7gMEEOP/Dr82YPauZFAyYmAQU4KkSk7CW6q/g440vf+fYS8wXA6eYWS4+wTiWNDZj6DlZOhriGHHpYDWIE9rYGAw/LqJgWFZC7AXuAxSAU0BprgDGyApkxVW0YHK4XLwAdqMoNp/53SG/9OA7ez/wJBhBRqoDuzI5gI7JpKqDP+vAcvmiUAzHt2EtLd/QpuSkVXgYVbwXoEOYDPyPLC7XDmLYdv/KIbaTqA1QDUCvNDGETRB/wKyv38HrTAHBjwwbfnYMzJYA9OaCDHDHR+BkfAMtOr9MmRs/CGQfvX4CkAAgZp3qdAeIe4hi9//GR4Au/HHgB2mw8Ai4MJtyKYFFmCq5uGGLL4GpVxcyzVBYQQ+SB7oi+5yRgZPjQcMDDOAnRK/cgZGZWOG/3OAJdfGGQyMgtCW4HdgTHkmMDDGd4B3Ef0/Cuxid+cwMLJ+Z3gZVsGwQ6SAQVWLm8Hy/XZg4OYx/AeawZg1E7y76P/2KQwMc2oYGP98BDVIgBHCB5SbDEzJcQz/gT1Mxhpgv0FRl+F38VqGqStYGKYs+c/AzcnIwMGOuW2ACXqM0ufvkEQiAAp4YEnpAiyNbAxB54MyEFFwg8FWgAACBTRofAN0vBQ8Gb8BnQF1kRGYUhkYTl4FNkVfIlIrLMXCiguCnURGSGfrx6//DKWJjAzJ/n8ZmJZXAAMH2Ds09WVgWAFM3svawK2C/8BUyGgdAKwhJzD8FwW2Nq7sY2Dsigda9JHhR2Y/w/T38QwzlrIwfH8N8ZuFMQNDDbAe1Pu8m4FhLjDlGgDb0REt4Cbg/7nA1smeRZCIk5JhYChZDDlq79Iehv+zMoCR2MjwRiuaoW4i5JhdUGoFFW24/AQ+958R0uoF7UcCLa8F7YHVUoIEvKvVfwZlGZwB3wQQQIxPXv2XfPeRYdaBUww+Ry78Z7j5ADTayAgOTNBpYaAVnkzQLQikLs4EpWTQuVagHQPRwNZZJbBxwXNqLrBJDuyS20Yx/N8xDVhk5EO26OsZAtvMwFYFaOPrvXPASg6o+Ntjhh8pkxlmvQxjmL0U0rvmRyrVQHsvvgCbafZALdXAVpzKG2B62T6H4b9JAAOjTQzD/5tHGRinpQArQ2BhbAsM5CpgM48PWFlvAdb/D4Bla840hsv3+BjKekD+ZgSfrQU7DIxggwsalqBcAAp0UAUP2vmgCkwfHtb/GdysGBkUpMFBDirEvAECiNEz+z/Do+cMWcDYnMrMjH9/BkktP0ZI6ngNLGLsgNmso4SBQebHCYb/z18yMBp4Mvw/C6wAa4IYGKWBrskEpmDzEGDZdpuBcWoG0PUvGX4kT2SYd8uZYfYSSH8GdAQRrgAARSbIs87AUqEUWBAqfgYm0ZPAZqOBL7DzYsHAuLUf2GSsBCa9MGD7CpjKv7xl+L9zGrhTw2AWxLB653+G9rmMDN9+QtbzU9QD/w8JfFAiACVQYCpfJ8zPkAkQQLCVu6ApA2CXjMGFWoEMsvAtMCWryv1n6ClhZNCTA5Y/j4DZRRbYFLx2lIGhL5qBIbiE4X8AsLL7AAz8WcAk+f0BMAVPZZh/zZxhxhxIAPNwE5fCmKAVNAgHukICXOwbsFJ5/BCYS6zAwwrgjT8qwPImHNiZeXaT4f/jKwyMGpYMXzmlGLqA9i3fAUmV4DqHOuntNzAs4r99Z1gOEEDIS6SDofODFC9+AR8kAMzSosByrzELVIYBC/hvnyDnxAPbyuARO+c0cLcePC318wXDt7A6hpknNRlmTQcG8E/IdS4MJBZXsKEJ0PQlaDNdiCewuEr5zyDODWwJ/GSBzJKA9i6DWiCSaqDjUCEaeIQY7j9lYKgHlmQnL0O2IzBRZ3IXFJ6gswK+AQQQckCzQFcZNTKQui4Oven3AzI8kB8NO96bERFq4DLlL8P//XMZGL8/Z/hhl8Iw+7A0w5TZkKlGUNsVpIySxfrgigu0c/EzJAtHeEJ2LwrjP7WI4cSl/wz1MxgZHj9jYKDCaWmgix5A2z7A65sBAohZSqcBeUIHtLxVHLpYhLy88gfSQglxBe3z+w+sTBlRGvv/bxxiYHx+luGnrg/D9JueDJmtfAwngIkctNcE1KKh1m4IyNYkSIBdvQNslGz4D55SNNBgBHegsAEZcUir4sw1RoY//zC2lJICQCtUC6A0GAAEEHJAM0CH6o9BVyNpk7yo6D+kUnI0AdZzaaAGP+J+hf/AHh2oiPglps0w56QBQ0Y7B8OpC4zgwGWj7VoncK8UtI/s3HVGhnnAAAfvfFJnxHJLDSODPrBEuQvsaV+7B5Eno3EASsGZDGir6wECCD2gQQA0oQjaMylKasoGdUpA56K25PwHby1kgA4IMjL+Z/jOxMMwd6coQ1ozC8ORs4wMXByM8PY4vQB4oA0Y4EfPMzIs2Aga+fzPoKvCAN5XhCh2GBl0gYF9HNiPAA0psLORZAVoP0cStvUdAAGELaBhQ+mboRP/NgTmrsElMGiMH9Rzas1lYNBVRYynfv/5n2HGakaG9EZIB4iXixE8evj/P8OAAVAvEBTou44zMsxdD+oV/mfQUUHc6AByo5o8ZDs/qMnHSlyNBTpQBLTM9Qo2SYAAwhXQMHAcOu8FWlyG8zAqUJn85+9/hupUyF0YsLJ6wcb/DKn1DAyHgCkYdMgIFyd9lusRC0CtC1CxtfMYI8MqYFsadB6vhiIjuP0rJQo5vwAU2KB6Bs+xtb/B01WQqyE+41IEEECEAhpW5sCO/rRFnhpghFY6oKHPbGBcJgQwgidaZq8F9qKb/jMcOgcpImh1OCu1AMh9//4zMuw4ygjuvIBOuVBXYAT28hjBww9ngWU7DxdWraByGDS9vZaQHQABhPdwWCwAtCAbtDXLjxHaLX/xGlgoBfxnKE9iZFi7Fyi5GLRrFeKwf/8YhhwA+Qt0NIOU+H+GtlxG8PhFdvt/YNOPkUFaFD7wBEp8hQyEDvNHAgABRGpAw1KyElBX5+dvDCGgw8E1FSADM6+A3W0BnsFVPJAb2KBhU9B55bqqoBYKqPhjYHj+muEONxdDKTAXbyDVTIAAIjegIZ0KJgbRv38YioGxnMvGwsDFyMgw7AAoBQMDfS8bM0MNIxPDiX//yRsPAgggijqawB70a2ATrQLYMeAGWu4LrTj/D5MwBh36WgfstIgBWyguwCL8BCWGAQQQNXdlbYFiUFMwCNqetGLAfZjjYAOg0he0VwV0I/VCBsq3BqMAgACixYZO0Dz0CigG5Rg1aMCDUrweA8a1sQMasA8YINdkrmRA7IekCQAIIIrKaPApgIwkaxVjAG1JhhwQYgbt6ksy0PYMBdCCBdCq/AsMkLPPT0JT7E9ihxYYoX4lt4wGCCAWOqciUKy+hOI9aBHABx3QkgZyFP9DttOJAz0F2mosCIxYUBEEGlNjRjLrJ3gIErLA4C3olhRgpx+03/s+0MhHQP4LBsjhKb8HOvsABBgAuqQDsQaWmqgAAAAASUVORK5CYII=',
                                width: 50,
                                height: 50,
                                fillColor: 'white',
          },
          { text: 'Assam Power Distribution Company Limited', style: 'header' },
          { text: 'New Service Connection Report of Domestic Consumers for the Financial Year '+this.curFinYear, style: 'subheader' },

          {
            style: 'tableExample',
            layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#80deea ' : null;
                    },

                },

  				   table: {
               headerRows: 1,
  				        body: temp
                     }
          },
          // { text: 'Generated Date: ' + today  + ' ' + currentDate.toLocaleTimeString() , style: 'normalText'},
             ],
             styles: {
                  header: {
                  fontSize: 20,
                  bold: true,
                  alignment: 'center',
                  margin: [0, 0, 0, 5]
              },
            subheader: {
                fontSize: 15,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            normalText: {
                fontSize: 8,
                alignment: 'center',
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [75, 5, 5, 0],
                alignment: 'center',
                fontSize: 10,
            }
        },

      };

      pdfMake.createPdf(docDefinition).download("Domestic_Consumers_New_Service_Connection_Report.pdf");
    }
  },
  mounted() 
  {
    this.currentFY("current");

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

/deep/ .table > tbody > tr > td {
text-align: right;
padding-bottom: 0%;
}
.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.2rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
